import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * "Talk for $3" button — Gumroad-powered.
 *
 * Fetches /api/gumroad/consultation/url on mount. If configured, clicking
 * opens Gumroad's hosted checkout in a new tab. If not configured (Architect
 * hasn't pasted the Gumroad product URL yet), the button shows "configuring"
 * and a click surfaces a friendly toast — per DIR-000 Truth Gate, no broken
 * pretend-checkout.
 */
export default function ConsultationButton({ variant = 'pill', className = '' }) {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/gumroad/consultation/url`)
      .then((r) => r.json())
      .then(setConfig)
      .catch(() => setConfig({ configured: false, url: null }));
  }, []);

  const handleClick = () => {
    if (!config?.configured) {
      toast.message('Consultation booking', {
        description:
          "We're setting up the new payment processor. Please email keywebco@gmail.com to book in the meantime.",
      });
      return;
    }
    window.open(config.url, '_blank', 'noopener,noreferrer');
  };

  const baseClasses =
    variant === 'pill'
      ? 'inline-flex items-center gap-2 px-5 py-2 rounded-full font-semibold text-sm tracking-wide bg-gradient-to-r from-amber-400 to-amber-600 text-black hover:from-amber-300 hover:to-amber-500 shadow-lg shadow-amber-500/30 transition-all'
      : 'inline-flex items-center gap-2 px-6 py-3 rounded-lg font-bold bg-amber-500 hover:bg-amber-400 text-black shadow-xl shadow-amber-500/40';

  const configuring = config && !config.configured;
  const label = configuring ? 'Talk for $3 · setting up' : 'Talk for $3 · 30 min';

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid="consultation-3-button"
      data-configured={config?.configured ? 'true' : 'false'}
      className={`${baseClasses} ${configuring ? 'opacity-90' : ''} ${className}`}
      title={
        configuring
          ? 'Payment processor being configured — email keywebco@gmail.com'
          : 'Book a 30-minute consultation with the Architect for $3.00'
      }
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
      {label}
    </button>
  );
}
